<template>
  <div v-show="show">
    <v-dialog v-model="model" width="800px" style="direction:ltr">
      <v-container class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title
                primary-title
                class="px-2 py-1 white--text secondary"
              >
                <h3 class="mx-2">{{ title }}</h3>
                <v-spacer></v-spacer>
                <v-btn class="ma-0" icon @click="close">
                  <v-icon color="white">close</v-icon>
                </v-btn>
              </v-card-title>
              <v-layout row wrap justify-center class="px-3">
                <p class="mt-3 text-xs-left flex xs12 subheading">
                  Please type <code>confirm</code> to confirm delete opreation.
                </p>

                <v-text-field
                  dense
                  outlined
                  single-line
                  hide-details
                  class="flex xs12"
                  @keyup.enter="confirm"
                  v-model="confirmTyped"
                  label="Delete Confirmation"
                />
              </v-layout>
              <v-card-actions class="di-flex justify-end px-3 pb-3">
                <div class="text-xs-right mt-5">
                  <v-btn flat @click="close">Cancel</v-btn>
                  <v-btn
                    color="primary"
                    @click="confirm"
                    :loading="loading"
                    :disabled="!checkConfirm"
                    >Delete</v-btn
                  >
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>
<script>
import { store } from "@/store";
export default {
  data() {
    return {
      path: "",
      show: false,
      loading: false,
      confirmTyped: null,
      confirmText: "confirm",
      title: "Delete Record",
      message: "Are you sure you want to delete selected record?",
    };
  },
  computed: {
    checkConfirm() {
      return this.confirmTyped === this.confirmText;
    },
    model: {
      get() {
        return this.show;
      },
      set() {
        this.close();
      },
    },
  },
  methods: {
    confirm() {
      if (this.checkConfirm) this.deleteItem();
      else this.close();
    },
    deleteItem() {
      this.loading = true;
      let vm = this;
      this.axios
        .delete(this.path)
        .then((resp) => {
          if (resp.data.success) {
            vm.success();
          } else {
            store.commit("showSnackbar", {
              stateType: "error",
              text: resp.data.msg,
              show: true,
            });
            this.close();
          }
        })
        .catch((err) => {
          console.log(err);
          let text = err.msg || err.message || err;
          store.commit("showSnackbar", {
            stateType: "error",
            text: text,
            show: true,
          });
          this.close();
        });
    },
    success() {
      this.show = false;
      this.loading = false;
      store.commit("showSnackbar", {
        text: "Record deleted successfully.",
        stateType: "success",
        show: true,
      });
    },

    close() {
      this.loading = false;
      this.show = false;
    },
  },
};
</script>
